import { render, staticRenderFns } from "./ConsultFinished.vue?vue&type=template&id=8b137216&scoped=true"
import script from "./ConsultFinished.vue?vue&type=script&lang=js"
export * from "./ConsultFinished.vue?vue&type=script&lang=js"
import style0 from "./ConsultFinished.vue?vue&type=style&index=0&id=8b137216&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b137216",
  null
  
)

export default component.exports